import AdaptiveCardsStyleOptions from './AdaptiveCardsStyleOptions';

const ADAPTIVE_CARDS_DEFAULT_STYLE_OPTIONS: Required<AdaptiveCardsStyleOptions> = {
  adaptiveCardsParserMaxVersion: undefined,
  cardEmphasisBackgroundColor: '#F0F0F0',
  cardPushButtonBackgroundColor: '#0063B1',
  cardPushButtonTextColor: 'White',
  richCardWrapTitle: false
};

export default ADAPTIVE_CARDS_DEFAULT_STYLE_OPTIONS;
